import { Row, Col } from "antd";
import StatCard from "components/statCard";
import { GitFork, UserRound, Dumbbell, UserRoundCog } from "lucide-react";
import React, { useMemo } from "react";

const formatStat = (value) => Number(value || 0).toLocaleString("pt-BR");

const BRANCH_STATS = [
  {
    key: "branches",
    subtitle: "Unidades",
    icon: GitFork,
    iconColor: "#09ac9c",
    getValue: (stats) => stats.branches,
  },
  {
    key: "userAdmin",
    subtitle: "Professores",
    icon: UserRoundCog,
    iconColor: "#1677ff",
    getValue: (stats) => stats.userAdmin,
  },
  {
    key: "users",
    subtitle: "Alunos",
    icon: UserRound,
    iconColor: "#595959",
    getValue: (stats) => stats.users,
  },
  {
    key: "control",
    subtitle: "Treinos Efetuados",
    icon: Dumbbell,
    iconColor: "#fa8c16",
    getValue: (stats) => stats.control,
  },
];

const BranchStats = ({ values }) => {
  const data = useMemo(() => {
    if (!values || !Array.isArray(values)) {
      return { branches: 0, userAdmin: 0, users: 0, control: 0 };
    }

    return values.reduce(
      (acc, item) => {
        acc.userAdmin += item.userAdmin || 0;
        acc.users += item.user || 0;
        acc.control += item.control || 0;
        return acc;
      },
      {
        branches: values.length,
        userAdmin: 0,
        users: 0,
        control: 0,
      }
    );
  }, [values]);

  return (
    <Row gutter={[16, 16]} className="branches-stats">
      {BRANCH_STATS.map(({ key, subtitle, icon: Icon, iconColor, getValue }) => (
        <Col key={key} xs={12} xl={6}>
          <StatCard
            title={formatStat(getValue(data))}
            subtitle={subtitle}
            icon={<Icon size={20} color="#fff" />}
            iconColor={iconColor}
          />
        </Col>
      ))}
    </Row>
  );
};

export default BranchStats;
